export const QUERY_KEYS = {
    tasks: {
        templates: {
            TASK_TEMPLATES: 'taskTemplates',
            TASK_TEMPLATES_ASSIGNEES: 'taskTemplatesAssignees',
            TASK_TEMPLATES_DETAILS: 'taskTemplateDetails',
        },
    },
    firebase: {
        events: {
            VISIBILITY_LAYERS: 'firebaseEventVisibilityLayers',
            GRID_LOCATION: 'firebaseEventGridLocation',
        },
    },
    notifications: {
        DASHBOARD_NOTIFICATIONS: 'dashboardNotifications',
        NOTIFICATION_PREFERENCES: 'notificationPreferences',
        GROUP_NOTIFICATION_PREFERENCES: 'groupNotificationPreferences',
    },
    widgetManagement: {
        WEATHER_CONFIG: 'weatherConfig',
    },
    widgetNotices: {
        NOTICES: 'widgetNotices',
    },
    airportStatus: {
        DASHBOARD_DATA: 'airportStatusDashboardData',
        METAR: 'metar',
        RUNWAY: 'runway',
        FLIGHT_CHARTS: 'airportStatusFlightCharts',
        BAGGAGE_DELIVERY: 'airportStatusBaggageDelivery',
        PAX_FORECAST_DETAIL: 'airportStatusPaxForecastDetail',
        SECURITY_QUEUE_HISTORY: 'airportStatusSecurityQueueHistory',
        QUEUES: 'airportStatusQueues',
        PAX: 'airportStatusPax',
        PAX_FORECAST: 'airportStatusPaxForecast',
        RESTRICTIONS: 'airportStatusRestrictions',
        TOWING: 'airportStatusTowing',
        CDM: 'airportStatusCdm',
        TOBT_LISTS: 'airportStatusTobtLists',
        OPERATIONAL_FORECAST: 'airportStatusOperationalForecast',
        WEATHER: 'airportStatusWeather',
        EVENTS: 'airportStatusEvents',
        NEWS_FEED: 'airportStatusNewsFeed',
    },
}
